import React from "react";
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import { LineChartData } from "./PerformanceTypes";
import { Box } from "@mui/material";
import {
  ChartTooltipContainer,
  ChartTooltipLabel,
  ChartTooltipValue,
} from "./PerformanceStyles";
import { calculateYAxisDomain } from "utils/KpiConfigUtils";

interface MetricLineChartProps {
  data: LineChartData;
  className?: string;
  goal?: number;
}

const MetricLineChart: React.FC<MetricLineChartProps> = ({
  data,
  className,
  goal,
}) => {
  const yDomain = calculateYAxisDomain(data.data || [], goal);

  if (data.isLoading) {
    return (
      <Box
        className={className}
        sx={{
          height: "120px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          borderRadius: "4px",
        }}
      >
        <i
          className="fas fa-spinner fa-spin"
          style={{ fontSize: "20px", color: "#666" }}
        ></i>
      </Box>
    );
  }

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <ChartTooltipContainer>
          <ChartTooltipLabel>
            {label}:{" "}
            <ChartTooltipValue>
              {payload[0].value.toLocaleString()}
            </ChartTooltipValue>
          </ChartTooltipLabel>
        </ChartTooltipContainer>
      );
    }
    return null;
  };

  return (
    <Box
      className={className}
      sx={{
        height: "80px",
        width: "100%",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <RechartsLineChart
          data={data.data}
          margin={{ top: 5, right: 10, left: -55, bottom: -25 }}
        >
          <CartesianGrid strokeDasharray="2 2" stroke="#f0f0f0" />
          <XAxis dataKey="date" tick={false} stroke="#999999" axisLine={true} />
          <YAxis
            tick={false}
            stroke="#999999"
            axisLine={true}
            domain={yDomain}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="current"
            stroke="#f18221"
            strokeWidth={2}
            dot={false}
            name={data.currentPeriodLabel || "Current Period"}
          />
          {goal !== undefined && (
            <ReferenceLine
              y={goal}
              stroke="#68717E"
              strokeDasharray="5 5"
              strokeWidth={2}
              label={{
                position: "right",
                fill: "#68717E",
              }}
            />
          )}
        </RechartsLineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default MetricLineChart;
